import * as React from "react"
import Svg, { SvgProps, Path } from "react-native-svg"
const LocationIcon = (props: SvgProps) => (
  <Svg
    width={24}
    height={24}
    fill="none"
    {...props}
  >
    <Path
      fill="#000"
      d="M12.099 11.73c.445 0 .825-.158 1.14-.475.315-.317.472-.698.472-1.143 0-.445-.158-.825-.475-1.14a1.565 1.565 0 0 0-1.143-.472c-.445 0-.825.159-1.14.476a1.563 1.563 0 0 0-.472 1.143c0 .445.158.825.475 1.14.317.315.698.472 1.143.472m-.003 7.946c1.88-1.636 3.366-3.3 4.458-4.991 1.092-1.692 1.638-3.155 1.638-4.39 0-1.83-.579-3.34-1.737-4.53-1.158-1.19-2.611-1.786-4.359-1.785-1.747 0-3.2.595-4.359 1.785-1.159 1.19-1.738 2.7-1.737 4.53 0 1.235.546 2.698 1.638 4.39 1.093 1.691 2.579 3.356 4.458 4.991Zm0 1.342c-2.35-2.078-4.12-4.016-5.31-5.814C5.596 13.407 5 11.771 5 10.296c0-2.115.689-3.86 2.066-5.234C8.444 3.687 10.121 3 12.096 3s3.652.687 5.03 2.062c1.377 1.374 2.066 3.119 2.066 5.234 0 1.475-.595 3.111-1.785 4.909-1.19 1.798-2.961 3.736-5.311 5.814Z"
    />
  </Svg>
)
export default LocationIcon
